import styled from 'styled-components';
import {
  Flex,
} from '../../../styled';

export const StyledComponent = styled(Flex)`
  flex-flow: column nowrap;
  height: calc(100% - 64px);
  background: #fff;
`;

export const CalendarBody = styled(Flex)`
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  overflow: auto;
`;

export const CalendarBodyWrapper = styled(Flex).attrs({
  id: 'calendar',
})`
  height: calc(100% - 36px);
  width: 100%;
`;

export const CalendarHeader = styled(Flex)`
  width: 100%;
  border-bottom-width: 0px;
  border-right-width: 0px;
  align-items: center;
`;

export const CalendarHeaderItem = styled(Flex)`
  flex: 1 1 14.28%;
  height: 100%;
  background: #fff;
  font-weight: 500;
  padding: 8px;
  &:not(:first-child) {
    border-left: 1px solid #f5f6f7;
  };
  &:last-child {
    border-right: 1px solid #f5f6f7;
  }
`;

CalendarBody.displayName = 'CalendarBody';
